/*funtion used by EBOOKS SECTION*/
import { pathname } from "../../Assets/javascripts/common/others/Configuration";
import $ from "jquery";
import SharedDispatcher from "../../Assets/javascripts/common/others/SharedDispatcher";

/*EBOOKS tri + pager*/

$('table.sortable').each(function () {
  var $table = $(this);

  $table.find('th').each(function (column) {
    var findSortKey;
    if ($(this).is('.sort-alpha')) {
      findSortKey = function ($cell) {
        return $cell.find('.sort-key').text().toUpperCase() + ' ' + $cell.text().toUpperCase();
      };
    } else if ($(this).is('.sort-numeric')) {
      findSortKey = function ($cell) {
        var key = parseFloat($cell.text());
        return isNaN(key) ? 0 : key;
      };
    } else if ($(this).is('.sort-date')) {
      findSortKey = function ($cell) {
        var targetDate = $cell.find('.up-date').text();
        var reg = targetDate.split("/");
        var date = new Date(reg[2], reg[1] - 1, reg[0]);
        var timestamp = date.getTime();
        return timestamp;
      };
    }

    if (findSortKey) {
      $(this).addClass('clickable')
        .hover(function () {
          $(this).addClass('hover');
        }, function () {
          $(this).removeClass('hover');
        })
        .click(function () {
          var newDirection = 1;
          if ($(this).is('.sorted-asc')) {
            newDirection = -1;
          }

          var rows = $table.find('tbody > tr.js4row').get();
          $.each(rows,
            function (index, row) {
              row.sortKey = findSortKey($(row).children('td').eq(column));
            }
          );

          rows.sort(
            function (a, b) {
              if (a.sortKey < b.sortKey) return -newDirection;
              if (a.sortKey > b.sortKey) return newDirection;
              return 0;
            }
          );

          $.each(rows,
            function (index, row) {
              $table.children('tbody').append(row);
              row.sortKey = null;
            }
          );

          $table.find('th').removeClass('sorted-asc').removeClass('sorted-desc');
          var $sortHead = $table.find('th').filter(':nth-child(' + (column + 1) + ')');
          if (newDirection === 1) {
            $sortHead.addClass('sorted-asc');
          } else {
            $sortHead.addClass('sorted-desc');
          }

          $table.find('td').removeClass('sorted')
            .filter(':nth-child(' + (column + 1) + ')')
            .addClass('sorted');


          $table.trigger('repaginate');
        });
    }
  });
});

$('table.repaginate').each(function () {
  var $table = $(this);
  var currentPage = 0;
  var numPerPage = 10;
  var numRows = $table.find('tbody tr.js4row').length;
  var numPages = Math.ceil(numRows / numPerPage);

  $("#numRows").text(numRows);

  if (numPages > 1) {

    /* fonction de repagination */
    $table.bind('repaginate', function () {
      var rows = $table.find('tbody tr.js4row');
      rows.show();
      rows.slice(0, currentPage * numPerPage).hide();
      rows.slice((currentPage + 1) * numPerPage).hide();

      currentPage > 0 ? $('.prev').css("visibility", "visible") : $('.prev').css("visibility", "hidden");
      currentPage < numPages - 1 ? $('.next').css("visibility", "visible") : $('.next').css("visibility", "hidden");
      //css("visibility", "visible");
      //css("visibility", "hidden");

      var str = currentPage + 1 + " / " + numPages;
      $('.pager-inner').html(str);

    }
    );


    $('.prev').click(function (e) { e.preventDefault(); currentPage -= 1; $table.trigger('repaginate'); });
    $('.next').click(function (e) { e.preventDefault(); currentPage += 1; $table.trigger('repaginate'); });

    /* Clonage du 2eme pager */
    $(".pager").clone(true).appendTo(".foot_orange .inner");
    $table.trigger('repaginate');
  }
});

/*cheque cadeau*/
{
  const myChecksLinks = $('.ma-MyChecks-RegisterLink');

  // Used on Src/www/Legacy/Account/OrderCCV/includes/Layout/CCVAccount.ascx
  if (myChecksLinks.length >= 2) {
    myChecksLinks.on('click', function () {
      myChecksLinks.toggleClass('ma-MyChecks-RegisterLink--active');
      $('.ma-MyChecks-RegisterContent').toggleClass('ma-MyChecks-RegisterContent--active');
    });

    // FIXME do that server side!
    let hasCSSCheckErrorMsgs = false;
    $(".js-giftCardRequired, .js-scratchCodeRequired").each(function (idx, el) {
      hasCSSCheckErrorMsgs = hasCSSCheckErrorMsgs || $(this).closest("span").css("display") !== "none";
    });

    if (hasCSSCheckErrorMsgs) {
      myChecksLinks.eq(1).trigger("click");
    }
  }
}

$('#ddlstGiftCardType').on("change", function () {
  const dataGiftCard = {
    // carte fnac
    0: ['6363', '29'],
    // Kadeo switch op.gifcard.kadeos
    1: ['6278', '52'],
    // Bestcadeau switch op.gifcard.bestcadeau
    2: ['9250', '00'],
    // Illicadeau switch op.gifcard.illicado
    3: ['9250', '004'],
    //
    4: ['6051', '00'],
    "sid": null
  };

  const caseId = parseInt($(this).val());
  const [txt1 = "", txt2 = ""] = dataGiftCard[caseId];

  const el1 = document.getElementById("KadeosCode_1");

  if (el1 !== null) {
    el1.value = txt1;
  }

  const el2 = document.getElementById("KadeosCode_2");
  if (el2 !== null) {
    el2.focus();
    el2.value = txt2;
  }
});

/*/Account/Profil/AccountInfos.aspx?LogonType=Standard - nbChildren*/
const registerNumChildrenSelect = $("#ddlNbChildren");
if (registerNumChildrenSelect.length) {
  registerNumChildrenSelect.on("change", function () {
    ShowChildren(true, $(this));
  });
  ShowChildren(false, registerNumChildrenSelect);
}

function ShowChildren(withEffect, ddpBD) {
  var arrayBirthDate = $.makeArray($("div[id*='wrapperBirthDate']"));
  var nbChildren = ddpBD.get(0).value;
  var i = 0;
  $.each(arrayBirthDate, function (index, value) {

    if (i < nbChildren) {
      if (withEffect === true)
        $('#' + value.id).show("fast");
      else
        $('#' + value.id).css('display', 'block');
    }
    else {
      if (withEffect === true)
        $('#' + value.id).hide("fast");
      else
        $('#' + value.id).css('display', 'none');
    }
    i++;
  });
}

/*/Common\Registration\Controls\MVC\CompanyName.ascx*/
if ($("#RegistrationMemberId_registrationContainer_companyName_checkCompany")) {
  if ($("#RegistrationMemberId_registrationContainer_companyName_checkCompany").attr('checked')) {
    $(".js-company").removeClass("hide");
  }
  $('#RegistrationMemberId_registrationContainer_companyName_checkCompany').on("change", function () {
    $(".js-company").toggleClass("hide");
  });
}

window.openInvoice = function openInvoice(urlInvoice) {
  var fen;
  fen = window.open(urlInvoice, 'Description', 'width=650,height=700,scrollbars=yes,left=0,top=0,resizable=yes,menubar=yes');
  fen.focus();
  return;
};

window.openInvoiceCCV = function openInvoiceCCV(urlInvoice) {
  var fen;
  fen = window.open(urlInvoice, 'Description', 'width=650,height=700,scrollbars=yes,left=0,top=0,resizable=yes,menubar=yes');
  fen.focus();
  return;
};

// Add a CSS helper class to account pages
$('body').addClass('account');

// Lancement autoComplete des magasins
{
  const delegate = 'body';
  const panel = '#PopinShop';
  const input = '.input input';
  const item = 'li';
  const validate = '.buttons input';

  $(delegate).on('keyup', panel + ' ' + input,
    function () {
      var searched = $.trim($(this).val().toLowerCase());
      if (validate !== null) {
        var selected = $(item + '.selected', panel);
        if (selected.length > 0) {
          var selected_value = selected.html().toLowerCase();
          var selected_noaccent = selected.data('noaccent');
          if (selected_noaccent !== null)
            selected_noaccent = selected_noaccent.toLowerCase();
          else
            selected_noaccent = "";
          if (searched === "" || selected_value.indexOf(searched) < 0 && selected_noaccent.indexOf(searched) < 0) {
            selected.removeClass('selected');
            $(validate, panel).addClass('hide');
          }
        }
      }

      $(item, $(this).parents(panel)).each(
        function () {
          var text_elem = text ? $(text, $(this)) : $(this);
          var value = text_elem.text().toLowerCase();
          var noaccent = $(this).data('noaccent');
          if (noaccent !== null)
            noaccent = noaccent.toLowerCase();
          else
            noaccent = "";
          if (value.indexOf(searched) < 0 && noaccent.indexOf(searched) < 0)
            $(this).addClass('hide');
          else
            $(this).removeClass('hide');
        });
      if (validate !== null) $(validate, panel).val();
    }
  );

  if (validate !== null)
    $(delegate).on('click', panel + ' ' + item, function () {
      $(input, panel).val($(this).text());
      $(item + '.selected', panel).removeClass('selected');
      $(validate, panel).removeClass('hide');
      $(this).addClass('selected');
    });

}


// action : mise � jour du magasin favori
$("body").on("click", "#PopinShop .buttons input", function (e) {
  if ($(".js-openPopInShop").data("source") !== "home-myaccount") return;

  var valueSelected, url;
  e.preventDefault();
  valueSelected = $('#PopinShop li.selected').data("value");
  url = $(".AjaxRequestUrl").data("url");

  $.ajax({
    type: "POST",
    url: url,
    data: { FavoriteStoreId: valueSelected },
    success: function (data) {
      $(".input input", "#PopinShop").val("");
      $(".selected", "#PopinShop").removeClass("selected");
      $('#FavoriteShopDetailInfoWrapperId, .ma-ShopFavorite').html(data);
      $("#PopinShop .js-PopInShop-close").click();
      window.location.reload();
    }
  });
});

$("body").on("click", ".js-openPopInShop", function (e) {
  SharedDispatcher.trigger("overlay:show");
  $("#PopinShop").removeClass("hide").addClass("PopInShop--active");
});

$(".js-PopInShop-close").on("click", function (e) {
  SharedDispatcher.trigger("overlay:hide");
  $("#PopinShop").addClass("hide").removeClass("PopInShop--active");
});
// Supprime la liste des �l�ments vus
$(".delete_histo").click(function (e) {
  e.preventDefault();

  var exchange = {
    update: {
      request: {
        type: 'lastseenitems/removealllastseenitems',
        value: 0
      }
    }
  };
  $.ajax({
    url: pathname + '/searchapi/' + exchange.update.request.type,
    data: JSON.stringify(exchange),
    contentType: "application/json",
    dataType: "json",
    beforeSend: function () {
      //if (options.noLayer !== true)
      $("#ajaxLoader").removeClass("hide");
    },
    error: function (xhr, status, error) {
      $("#ajaxLoader").addClass("hide");
    },
    success: function (obj) {
      $("#last_seen ul li").remove();
    }
  });
});

$('#col_centre').shutter({
  selectors: {
    button: '.OrderViewModel .ShipmentInfos a.FollowPackageBtn',
    item: '.OrderViewModel .wrapper_Edi'
  },
  oneOpenedItem: true
});

// Trigger pour refermer le wrapper EDI
$(".wrapper_Edi .expList .FollowPackageBtn ").click(function (e) {
  e.preventDefault();
  $(this).parent().parent().parent().parent().parent().prev().find(".ShipmentInfos a.FollowPackageBtn").click();
});


// bouton radio perso (annulation)
//$(".ToRemove").radio({
//    elemRadioClass: "isRadio",
//    baseClass: "myImg"
//});



// alignement des blocs d'infos droite //
$(".articleList").each(function (i) {
  var b, c, d, e;
  c = $(this).outerHeight(); // Hauteur de la liste de produit
  d = $(this).next().outerHeight(); // Hauteur du block de suivi de commande
  e = $(this).children().outerHeight(); // Hauteur de la liste de produits

  if (c > 140 && c < 300) {
    b = parseInt((c - d) / 2);
    $(this).next().css("top", b + "px");
  } else if (c > 300) {
    $(this).next().css("top", "100px");
  }

  if (d > c) {
    $(this).css("min-height", d + "px");
    var f = parseInt((d - e) / 2); // calcul de la position de la liste d'article selon la taille du bloc de suivi de commande
    $(this).children().css("margin-top", f + "px");
  }

});


// Gestion Menu
// Attribution des data-item sur chaque �l�ment qui se d�pli
var sizeCount;
var ishome = $(".myHome").length > 0 ? 1 : 0;
// Attribution des data-item sur chaque �l�ment qui se d�pli
$("dt", "#navigationMyAccount").each(function (i) {
  $(this).data("item", i); // dynamiq set data-items
});

// load sessionStorage
if (sessionStorage.menuMyAccountCategory === undefined)
  sessionStorage.menuMyAccountCategory = 0;

sizeCount = $(".listToOpen", "#navigationMyAccount").length - 1;

$("dt", "#navigationMyAccount").click(function () {
  var i;
  i = $(this).data("item");
  $(this).addClass("opened");
  if (sessionStorage.menuMyAccountCategory && i !== sessionStorage.menuMyAccountCategory) {
    $("#navigationMyAccount dt").eq(sessionStorage.menuMyAccountCategory).removeClass("opened");
    if ($("#navigationMyAccount dt").eq(sessionStorage.menuMyAccountCategory).hasClass("openMenu")) {
      $("#navigationMyAccount dt").eq(sessionStorage.menuMyAccountCategory).click();
    }
  } else {
    sessionStorage.setItem("menuMyAccountCategory", i);
  }
  sessionStorage.setItem("menuMyAccountCategory", i);
});

// Permet d'enregistrer la cat�gorie de l'element cliqu� et la mettre en sessionStorage
$("dd a", "#navigationMyAccount").click(function () {
  var list_item_position, valueSelected, item_position;

  item_position = $(this).parent().index(); // Index de l'element cliqu�
  list_item_position = $(this).parent().parent().parent().prev();

  $(this).parent().parent().find(".selected").removeClass("selected");
  $(this).parent().addClass("selected");

  valueSelected = list_item_position.data("item"); // index de la cat�gorie
  sessionStorage.setItem("menuMyAccountCategory", valueSelected);
  sessionStorage.setItem("menuMyAccountSubCategory", item_position);
});

if (ishome) {
  sessionStorage.clear();
  sessionStorage.setItem("menuMyAccountCategory", 0);
}

if (sessionStorage.menuMyAccountCategory !== null) // controle du session Storage
  $("#navigationMyAccount dt:eq(" + sessionStorage.menuMyAccountCategory + ")").addClass("opened");
if (sessionStorage.menuMyAccountSubCategory !== null)
  $("#navigationMyAccount dt:eq(" + sessionStorage.menuMyAccountCategory + ")").next().find("li:eq(" + sessionStorage.menuMyAccountSubCategory + ")").addClass("selected");

var rDTopen = null; // DT s�lectionn� r��l

$("dt.openMenu", "#navigationMyAccount").each(function (i) {
  if ($(this).hasClass("opened"))
    rDTopen = i;
});

if (!rDTopen) {
  if (sessionStorage.menuMyAccountCategory) {
    if ($("#navigationMyAccount").length > 0) {
      var cTagName = $("#navigationMyAccount dt:eq(" + sessionStorage.menuMyAccountCategory + ")").next().get(0).tagName.toLowerCase();
      if (cTagName !== "dd") {
        rDTopen = -1;
      }
    }
  } else {
    rDTopen = -1;
  }
}

// Appel du plugin de open/close element
$('#navigationMyAccount').shutter({
  selectors: {
    button: 'dt.openMenu',
    item: 'dd.listToOpen'
  },
  open: rDTopen !== null ? rDTopen : 0,
  speed: 200,
  oneOpenedItem: true
});

$(document).on("focus", "#NewPassword", function () {
  if ($("#NewPassword").val() === "") {
    $(".js-password-click-to-show").removeClass("hide");
  }
});

// Check new password input
{
  var $newPassword = $("#NewPassword");
  var $firstName = $("#FirstName");
  var $lastName = $("#LastName");

  var $rules = $(".js-password-checker__rule");
  var $meter = $(".js-password-checker__meter");

  var $strength = $(".js-password-checker__strength");
  var $weak = $(".js-password-checker__strength--weak");
  var $average = $(".js-password-checker__strength--average");
  var $strong = $(".js-password-checker__strength--strong");

  var url = pathname + '/identity/api/Password/v1/scoring';

  $(document).on("input", "#NewPassword", function () {
    var password = $newPassword.val();
    var firstName = $firstName.val();
    var lastName = $lastName.val();

    var payload = {
      'firstName': firstName,
      'lastName': lastName,
      'password': password
    };

    if (password !== '') {
      $.ajax(url, {
        type: "POST",
        data: JSON.stringify(payload),
        contentType: "application/json",
        success: function (data) {
          $strength.addClass("hide");

          $rules.each(function () {
            var $this = $(this);
            var regex = $this.data("regex");

            if (RegExp(regex).test(password)) {
              $this.addClass("password-checker__rule--valid");
            } else {
              $this.removeClass("password-checker__rule--valid");
            }
          });

          //weak
          if (data.Score < 2) {
            $newPassword.removeClass("valid");
            $newPassword.addClass("input-validation-error");
            $weak.removeClass("hide");
            $meter.attr("value", 1);

            //average
          } else if (data.Score < 4) {
            $average.removeClass("hide");
            $meter.attr("value", 2);

            //strong
          } else if (data.Score === 4) {
            $strong.removeClass("hide");
            $meter.attr("value", 4);
          }
        }
      });
    } else {
      $strength.addClass("hide");
      $rules.removeClass("password-checker__rule--valid");
      $meter.attr("value", 0);
    }
  });
}
